<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: ['data'],
  data() {
    return {
      chartData: {
        datasets: [
          {
            data: [this.data, 100 - this.data],
            borderColor: 'transparent',
            backgroundColor: ['#007aff', '#eee'],
            hoverBackgroundColor: ['#007aff', '#eee'],
            tooltip: [
              {
                enabled: false,
              },
            ],
          },
        ],
      },
      chartOptions: {
        cutoutPercentage: 90,
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
};
</script>




// WEBPACK FOOTER //
// src/components/CompChartCircle.vue